import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import marketingSmsTemplateAPI from '../apis/marketingSmsTemplateAPI'
import alertMessage from '../utils/alertMessage'

export default class MarketingSmsTemplateStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable pageSizeNotice = PAGE_SIZE_DEFAULT
  @observable pageNoNotice = 1
  @observable currIndexNotice = 0
  @observable itemCountNotice = 0

  //下拉列表
  @observable signList = []
  @action
  async onGetSign(params) {
    this.signList = []
    try {
      const response = await marketingSmsTemplateAPI.getSign(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.signList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
  //Status 下拉列表
  @observable statusList = []
  @action
  async onGetStatus(params) {
    this.statusList = []
    try {
      const response = await marketingSmsTemplateAPI.getStatus(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.statusList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
  //下拉列表
  @observable groupList = []
  @action
  async onGetGroup(params) {
    this.groupList = []
    try {
      const response = await marketingSmsTemplateAPI.getGroup(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.groupList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }

  /*SearchResult start*/
  @observable searchItem = {
    'groupName': '',
    'configName': '',
    'templateType': '',
    'isPowerUser' : false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []
  @action
  async onSearchAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await marketingSmsTemplateAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }
  /*SearchResult end*/

  /*add */
  @action
  async onAddAction(params, title) {
    this.isFetching = true
    try {
      const response = await marketingSmsTemplateAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          this.onSearchAction(this.searchItem)
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit*/
  @observable detailsObj = null
  @action
  async onGetAction(params) {
    this.isFetching = true
    try {
      const response = await marketingSmsTemplateAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data
        if (response.data.code === 0) {
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*delete*/
  @action
  async onDeleteAction(params) {
    this.isFetching = true
    try {
      const response = await marketingSmsTemplateAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSearchAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onSyncAction(){
    this.isFetching = true
    try {
      const response = await marketingSmsTemplateAPI.syncAction()
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('同步成功！')
          this.onSearchAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('同步失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchAction({
      'groupName': this.searchItem.groupName,
      'configName': this.searchItem.configName,
      'templateType': this.searchItem.templateType,
      'isPowerUser' : this.searchItem.isPowerUser,
      'page': pageNo,
      'size': pageSize,
    })
  }

}
